/* Wishlist — stored in localStorage on this browser/device, no account or app needed. */
(function () {
  var STORAGE_KEY = 'mne_wishlist';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private browsing etc) — fail silently */
    }
  }

  function isWishlisted(handle) {
    return getWishlist().some(function (item) {
      return item.handle === handle;
    });
  }

  function toggleWishlist(handle, productId) {
    var list = getWishlist();
    var index = list.findIndex(function (item) {
      return item.handle === handle;
    });

    var nowActive;
    if (index > -1) {
      list.splice(index, 1);
      nowActive = false;
    } else {
      list.push({ handle: handle, id: productId });
      nowActive = true;
    }

    saveWishlist(list);
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { handle: handle, active: nowActive } }));
    return nowActive;
  }

  function updateHeartButtons(handle, active) {
    document.querySelectorAll('.wishlist-heart-btn[data-product-handle="' + CSS.escape(handle) + '"]').forEach(function (btn) {
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function syncAllHearts() {
    var list = getWishlist();
    var handles = list.map(function (item) { return item.handle; });
    document.querySelectorAll('.wishlist-heart-btn').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = handles.indexOf(handle) > -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateHeaderCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.wishlist-heart-btn');
    if (!btn) return;
    event.preventDefault();

    var handle = btn.getAttribute('data-product-handle');
    var productId = btn.getAttribute('data-product-id');
    if (!handle) return;

    var active = toggleWishlist(handle, productId);
    updateHeartButtons(handle, active);
    updateHeaderCount();
  });

  document.addEventListener('wishlist:changed', function () {
    updateHeaderCount();
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncAllHearts();
    updateHeaderCount();
    renderWishlistPage();
  });

  /* ---- Touch "tap to reveal" — mimics hover on devices that don't have it ----
     First tap on a product image reveals the heart/plus icons (and doesn't
     navigate). A second tap on that same image navigates through as normal.
     Tapping anywhere else closes any open card. Runs in the capture phase so
     it gets first refusal on the click, before the theme's own link handling. */
  function isTouchDevice() {
    return window.matchMedia('(hover: none)').matches;
  }

  document.addEventListener('click', function (event) {
    if (!isTouchDevice()) return;

    var link = event.target.closest('.image-cont .product-link');
    var imageCont = link ? link.closest('.image-cont') : null;

    if (!imageCont) {
      document.querySelectorAll('.image-cont.is-touch-active').forEach(function (el) {
        el.classList.remove('is-touch-active');
      });
      return;
    }

    if (!imageCont.classList.contains('is-touch-active')) {
      event.preventDefault();
      event.stopPropagation();
      document.querySelectorAll('.image-cont.is-touch-active').forEach(function (el) {
        if (el !== imageCont) el.classList.remove('is-touch-active');
      });
      imageCont.classList.add('is-touch-active');
    }
    /* else: already revealed, let the tap through to navigate */
  }, true);

  /* ---- Wishlist page rendering ---- */
  function renderWishlistPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (!container) return;

    var list = getWishlist();
    if (list.length === 0) {
      container.innerHTML = '';
      var empty = container.parentElement.querySelector('[data-wishlist-empty]');
      if (empty) empty.hidden = false;
      return;
    }

    var empty2 = container.parentElement.querySelector('[data-wishlist-empty]');
    if (empty2) empty2.hidden = true;

    container.innerHTML = '<div class="wishlist-page__loading">Loading your saved items\u2026</div>';

    Promise.all(
      list.map(function (item) {
        return fetch('/products/' + item.handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var grid = document.createElement('div');
      grid.className = 'wishlist-page__grid';

      var anyValid = false;

      products.forEach(function (product, i) {
        if (!product) {
          /* Product no longer exists or is unavailable — quietly drop it from storage */
          var stale = list[i];
          var current = getWishlist().filter(function (entry) { return entry.handle !== stale.handle; });
          saveWishlist(current);
          return;
        }
        anyValid = true;

        var variant = product.variants && product.variants[0];
        var image = product.featured_image || (product.images && product.images[0]);

        var item = document.createElement('div');
        item.className = 'wishlist-page__item';
        item.innerHTML =
          '<a class="wishlist-page__item-image" href="' + product.url + '">' +
            (image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '">' : '') +
          '</a>' +
          '<button type="button" class="wishlist-page__item-remove" data-wishlist-remove data-handle="' + product.handle + '" aria-label="Remove from wishlist">' +
            '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.6z" fill="currentColor"/></svg>' +
          '</button>' +
          '<a href="' + product.url + '" class="wishlist-page__item-title">' + escapeHtml(product.title) + '</a>' +
          '<div class="wishlist-page__item-price">' + formatMoney(product.price) + '</div>' +
          '<button type="button" class="wishlist-page__item-atc" data-wishlist-atc data-variant-id="' + (variant ? variant.id : '') + '"' + (variant && variant.available ? '' : ' disabled') + '>' +
            (variant && variant.available ? 'Add to cart' : 'Sold out') +
          '</button>';

        grid.appendChild(item);
      });

      container.innerHTML = '';
      if (anyValid) {
        container.appendChild(grid);
      } else {
        var emptyEl = container.parentElement.querySelector('[data-wishlist-empty]');
        if (emptyEl) emptyEl.hidden = false;
      }

      updateHeaderCount();
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.settings && window.theme.settings.moneyWithCurrencyFormat) {
      var amount = (cents / 100).toFixed(2);
      return window.theme.settings.moneyWithCurrencyFormat.replace('{{amount}}', amount).replace(/<[^>]+>/g, '');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      event.preventDefault();
      var handle = removeBtn.getAttribute('data-handle');
      var list = getWishlist().filter(function (item) { return item.handle !== handle; });
      saveWishlist(list);
      updateHeaderCount();
      renderWishlistPage();
      return;
    }

    var atcBtn = event.target.closest('[data-wishlist-atc]');
    if (atcBtn && !atcBtn.disabled) {
      event.preventDefault();
      var variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
      atcBtn.disabled = true;
      var originalText = atcBtn.textContent;
      atcBtn.textContent = 'Adding\u2026';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          atcBtn.textContent = originalText;
          atcBtn.disabled = false;
        })
        .catch(function () {
          atcBtn.textContent = originalText;
          atcBtn.disabled = false;
        });
    }
  });
})();
